/*
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2024, Zumper
 */

import { event } from '@zcode-ui/web-zumper-integrations'
import { PAGE_NAMES, PROP_NAMES } from '@zcode/mixpanel'
import { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import { useDispatch } from 'react-redux'
import { mixpanelViewSection } from '../../../modules/mixpanel/thunks/mixpanelViewSection'

interface Props {
  cityState?: string
  tab?: string
  link?: string
  linkSection?: string
}

interface UseHomePageImpressionProps {
  mixpanelSection?: string
  name: string
  props?: Props
}

export const useHomepageImpression = ({
  mixpanelSection,
  name,
  props,
}: UseHomePageImpressionProps) => {
  const [ref, inView] = useInView({ triggerOnce: true })
  const dispatch = useDispatch()
  useEffect(() => {
    if (inView) {
      dispatch(event({ name, props: { pageType: PAGE_NAMES.HOMEPAGE, ...props } }))
      mixpanelSection &&
        dispatch(
          mixpanelViewSection(mixpanelSection, { [PROP_NAMES.PAGE_NAME]: PAGE_NAMES.HOMEPAGE })
        )
    }
  }, [inView])
  return ref
}
